module.exports = __webpack_public_path__ + "img/conciliation.e14acc52.svg";